import React from 'react';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

type Props = {
  children: React.ReactNode;
};

/**
 * This ensures that Emotion's styles are inserted before our own styles so that our own classes have precedence over Emotion
 * See: https://react-select.com/styles#the-classnames-prop
 * @param children
 * @constructor
 */
export const EmotionCacheProvider: React.FC<Props> = ({ children }) => {
  const cache = React.useMemo(
    () =>
      createCache({
        key: 'react-select-cache',
        // Use meta tag that is set in index.html as the top-most element and is expected to never be altered by any process
        // Using title, as suggested by react-select, might lead to issues when changing title tag on page transitions.
        insertionPoint: document.querySelector('meta[charset="UTF-8"]') as HTMLElement,
      }),
    [],
  );

  return <CacheProvider value={cache}>{children}</CacheProvider>;
};
